// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';
import awsLaunchStackButtonImage from '../../images/aws-launch-stack-button.svg';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  elementProps: PropTypes.object
};

MarkdownComponent.defaultProps = {
  elementProps: {}
};

MarkdownComponent['title'] = 'AWS';

function MarkdownComponent(props) {
  const { className, style, elementProps } = props;

  return (
    <div className={className} style={style}>
      <h2 {...elementProps['h2']}>Install the Agent on your own AWS instance</h2>
      <p {...elementProps['p']}>To run the agent on your own AWS instances use whichever installer matches your instance type. For Amazon Linux use the RH/CentOS installer.</p>
      <h2 {...elementProps['h2']}>Use our pre-built Elastic CI Stack for AWS</h2>
      <p {...elementProps['p']}>The <a href="https://github.com/buildkite/elastic-ci-stack-for-aws" {...elementProps['a']}>Elastic CI Stack for AWS</a> is a pre–built CloudFormation template that gives you an autoscaling agent cluster including Docker, S3 and CloudWatch integration. <a href="https://github.com/buildkite/elastic-ci-stack-for-aws" {...elementProps['a']}>Read the documentation</a> on GitHub, and launch it using the details below:</p>
      <p {...elementProps['p']}><a href="https://console.aws.amazon.com/cloudformation/home#/stacks/new?stackName=buildkite&templateURL=https://s3.amazonaws.com/buildkite-aws-stack/aws-stack.json" target="_blank" {...elementProps['a']}>{<img src={awsLaunchStackButtonImage} alt="Launch Buildkite Elastic CI Stack" width="144" height="27"/>}</a></p>
      <p {...elementProps['p']}>You will need your <strong {...elementProps['strong']}>BuildkiteAgentToken</strong> when launching the stack:</p>
      <pre {...elementProps['pre']}><code {...elementProps['code']}><span className="hljs-attribute" {...elementProps['span']}>{props.token || 'INSERT-YOUR-AGENT-TOKEN-HERE'}</span><br {...elementProps['br']} /></code></pre>
      <p className="rounded bg-silver p2" {...elementProps['p']}>We recommend following AWS best practice by setting up a separate development AWS account and using role switching and consolidated billing. See the AWS tutorial on <a href="http://docs.aws.amazon.com/IAM/latest/UserGuide/tutorial_cross-account-with-roles.html" {...elementProps['a']}>access delegation across AWS accounts</a>, and <a href="https://github.com/buildkite/elastic-ci-stack-for-aws" {...elementProps['a']}>Elastic CI Stack repository on GitHub</a> for full documentation.</p>
    </div>
  );
};

export default MarkdownComponent;
